import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PartnerService } from '../../../../../../services/partner.service';
import { HelpersService } from '../../../../../../services/helpers.service';

@Component({
  selector: 'app-netsuite-defaults',
  templateUrl: './netsuite-defaults.component.html',
  styleUrls: ['./netsuite-defaults.component.scss'],
})
export class NetsuiteDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public subsidiaries: any = [];
  public locations: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;
  public technicians: any = [];
  public technician: any;

  public isWorkshop = true;
  public gettingData = true;
  public isRentals = false;
  public busyTechnicians = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/pos-integrations'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }

    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getLocations();

    this.getConfig();
    this.getTechnicians();
    this.getUsers();
  }

  getConfig() {
    this.posIntegrationService.getConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;
        //this.config.POSEmployeeID = (res.EmployeeID).toString();
        console.log(this.config);
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
    this.busy = false;
  }

  getLocations() {
    this.gettingData = true;
    this.posIntegrationService.getLocations(this.partnerID).subscribe((res) => {
      console.log(res);

      var results = ([] = res);

      results.forEach((x) => {
        if (this.locations.findIndex((y) => y.value == x.ID) == -1)
          this.locations.push({
            label: x.ID.toString() + ' - ' + x.Name,
            value: x.ID.toString(),
          });
      });

      results.forEach((x) => {
        if (this.subsidiaries.findIndex((y) => y.value == x.ParentID) == -1)
          this.subsidiaries.push({
            label: x.ParentID.toString() + ' - ' + x.Description,
            value: x.ParentID.toString(),
          });
      });

      this.locations = this.locations.sort((a, b) => a.value - b.value);
      this.subsidiaries = this.subsidiaries.sort((a, b) => a.value - b.value);
      this.gettingData = false;
      console.log(this.subsidiaries, this.locations);
    });
  }

  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;
    this.posIntegrationService
      .updateConfig(this.partnerID, this.config)
      .subscribe(
        (result) => {
          this.busy = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant('onboarding.pos_settings_updated'),
          });
          this.status.emit({ configurationSaved: true });
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechnicians(this.helpersService.getPartnerId())
      .subscribe((technicians) => {
        console.log(technicians);
        this.technicians = technicians
          .filter((x) => {
            return x.IsActive === true;
          })
          .map((x) => {
            return {
              ...x,
              POSEmployeeID: x.POSEmployeeID ? parseInt(x.POSEmployeeID) : null,
            };
          });
      });
  }

  getUsers() {
    this.posIntegrationService.getUsers(this.partnerID).subscribe((res) => {
      console.log(res);
      this.users = res.map((x) => {
        return {
          label: x.Firstname + ' ' + x.Surname,
          value: x.POSEmployeeID ? parseInt(x.POSEmployeeID) : null,
        };
      });
    });
  }

  updateTechnicians() {
    this.busyTechnicians = true;
    this.partnerService
      .updateTechnicianPOSEmployee(
        this.partnerID,
        this.technicians.map((x) => {
          return { TechnicianID: x.ID, POSEmployeeID: x.POSEmployeeID };
        }),
      )
      .subscribe((result) => {
        this.busyTechnicians = false;
      });
  }
}
